import { getContactLatestInteraction } from '@/services/contact-service.js';
import store from '@/store';

export const getPhonesFromContact = (contact) =>
  Object.keys(contact).reduce((phones, propertyContact) => {
    if (isPhoneField(propertyContact)) {
      return contact[propertyContact]
        ? phones.concat(contact[propertyContact])
        : phones;
    }
    return phones;
  }, []);

const isPhoneField = (field) => {
  const fieldIdentifierPhone = /phone/g;
  const isPhone = fieldIdentifierPhone.test(field);
  return isPhone && isNotPhoneScore(field);
};

const isNotPhoneScore = (field) => {
  const blackListPhone = /score/g;
  return !blackListPhone.test(field);
};

/**
 * Responsável por criar o id dinamico (contact_identifier) na tela de criação de contato.
 * @param {*} agentId
 * @returns
 */
export const generateContactIdentifier = (agentId) => {
  return (Math.random(Date.now()) + '-' + agentId).substr(2);
};

export const createContactObject = (contactInformation, agentId, type) => {
  let newContact = {};

  if (type == 'save') {
    const channel = contactInformation.channel.toLowerCase();
    const contactIdentifier = generateContactIdentifier(agentId);
    const phoneNumber = contactInformation.phone
      ? contactInformation.phone
      : '';
    const chatIdentifier = contactInformation.contactIdentifier
      ? contactInformation.contactIdentifier
      : '';
    const whatsAppIdentifier = contactInformation.contactIdentifier
      ? contactInformation.contactIdentifier
      : '';

    switch (channel) {
      case 'voice':
        newContact.contact_identifier = contactIdentifier;
        newContact.contact_phone1 = phoneNumber;
        newContact.fullname = phoneNumber;
        break;
      case 'whatsapp':
        newContact.contact_identifier = contactIdentifier;
        newContact.whatsapp_identifier = whatsAppIdentifier;
        newContact.fullname = whatsAppIdentifier;
        break;
      case 'chat':
        newContact.contact_identifier = contactIdentifier;
        newContact.chat_identifier = chatIdentifier;
        newContact.fullname = chatIdentifier;
        break;
    }
  } else {
    newContact.id = contactInformation.contactId;
  }

  if (
    contactInformation.contactFullname != null ||
    contactInformation.contactFullname != ''
  ) {
    newContact.fullname = contactInformation.contactFullname;
  }

  return newContact;
};

export const selectContactByLatestInteraction = async (
  contactList,
  contactIdentifier,
  channel,
  whatsAppRoute = null,
) => {
  const agentId = store.state.attendance.Attendance.agentId;
  const orgUnitId = store.state.attendance.orgUnitInformation.id;

  let contactId = await getContactLatestInteraction(
    agentId,
    contactIdentifier,
    orgUnitId,
    channel,
    whatsAppRoute,
  );

  if (contactId == null) {
    return contactList[0];
  }

  const latestContact = contactList.find(
    (contact) => Number(contact.id) == Number(contactId),
  );

  if (latestContact != undefined) {
    return latestContact;
  }

  return contactList[0];
};

export const getContactColor = (contactName) => {
  const colors = [
    '#ED2D2D',
    '#F00055',
    '#FE0089',
    '#D138B0',
    '#A400F1',
    '#6E00FB',
    '#366CF6',
    '#2196F3',
    '#00A8C2',
    '#00BEB3',
    '#0CA678',
    '#0CA625',
    '#77CD00',
    '#FFC53A',
    '#F59F00',
    '#F59F00',
    '#FF00B8',
    '#B600C6',
    '#01579B',
    '#0189B4',
    '#017B8E',
    '#00867E',
    '#DD3429',
    '#A61E4D',
    '#AB5D01',
    '#870075',
    '#F5683B',
  ];

  if (!contactName) return colors[0];

  let hash = 0;
  for (let i = 0; i < contactName.length; i++) {
    hash = contactName.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash % colors.length)];
};

/**
 * formatContactForUpdate
 * Responsável por formatar o contato para atualização, removendo propriedades que não são necessárias para a atualização e que possam causar erros.
 * @param {Object} contact
 * @returns {Object}
 */
export const formatContactForUpdate = (contact) => {
  const contactCopy = JSON.parse(JSON.stringify(contact));
  delete contactCopy.lastContact;
  delete contactCopy.selected;
  return contactCopy;
};
